module.exports = __webpack_public_path__ + "media/images/athletes/4309-e590393fd9e0447d233018a54e829eb7.png";